'use client';
import { load } from 'cheerio';
import React, { useRef } from 'react';
import styles from './article.module.css';

const Content = React.memo(({ content }) => {
  const contentRef = useRef(null);

  const renderRichText = (htmlContent) => {
    const $ = load(htmlContent ?? '');

    // Add id attributes to h1 tags
    $('h1').each((index, element) => {
      const sectionId = `section-${index + 1}`;
      $(element).attr('id', sectionId);
      $(element).attr('class', 'blog-content-heading');
    });

    return { __html: $.html() };
  };

  return (
    <div
      ref={contentRef}
      className={`w-full no-scrollbar ${styles.articleSection}`}
      dangerouslySetInnerHTML={renderRichText(content)}
    />
  );
});

Content.displayName = 'Content';

export default Content;
